@let _everyInvoiceBelongsToSameBusinessEntity = everyInvoiceBelongsToSameBusinessEntity();
@for (invoice of invoices(); track invoice.arTranId) {
  <div class="mt--075">
    <app-invoice-mobile-card
      [everyInvoiceBelongsToSameEntity]="_everyInvoiceBelongsToSameBusinessEntity"
      [invoiceTableDataObject]="invoice"
    ></app-invoice-mobile-card>
  </div>
}
